import * as React from "react";
import { Box, Table, TableBody } from "@material-ui/core";

import { Source } from "services/valuation/types";

import SourceBreakdownTableRow from "./SourceBreakdownTableRow";

interface SourceBreakdownTableProps {
  colors: string[];
  sources: Source[];
  totalValue: number;
}

const SourceBreakdownTable: React.FC<SourceBreakdownTableProps> = ({
  sources,
  colors,
  totalValue,
}) => {
  return (
    <Box>
      <Table aria-label="source-breakdown-table">
        <TableBody>
          {sources.map((source: Source, index: number) => (
            <SourceBreakdownTableRow
              key={`row-${source.name}-${index}`}
              source={source}
              color={colors[index % colors.length]}
              totalValue={totalValue}
            />
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default SourceBreakdownTable;
